<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="bars"></nb-icon>
    </a>
    <a class="logo d-none d-sm-block" href="#" (click)="navigateHome()">
      محمد فون
    </a>
  </div>
  <nb-select
    [selected]="currentTheme"
    size="small"
    id="theme-select"
    (selectedChange)="changeTheme($event)"
    status="primary"
  >
    <nb-option *ngFor="let theme of themes" [value]="theme.value">
      {{ theme.name }}</nb-option
    >
  </nb-select>
  <div class="full-screen" (click)="toggleFullScreen()">
    <ng-container *ngIf="!fullScreen; else shrinkTemp">
      <nb-icon icon="expand"></nb-icon>
    </ng-container>
    <ng-template #shrinkTemp>
      <nb-icon icon="compress"></nb-icon>
    </ng-template>
  </div>
</div>
